export enum RelationType {
  singleObject = 0,
  array = 1,
  dictionary = 2,
  collection = 3 // TODO: temporary - remove once createEmbeddedModel is refactored to be part of repo/provider/collection logic
}